const Partner = () => import('./Partner.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: Partner,
  path: '/parceiros',
  meta: {
    label: 'Parceiros'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'partnersList',
      meta: {
        label: 'Gerenciar Parceiros',
        requiredPermission: {resource: 'partner', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'partnerCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'partner', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'partnerEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'partner', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/partner/routes.js